// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"01d9405f","703":"5e3cf4eb"}[chunkId] + ".chunk.js";
};